// Esempio: importa dipendenze npm dove ti servono
// import Splide from '@splidejs/splide';
// import '@splidejs/splide/css';

import { initSelect2 } from './components/select2-init';
import { initBreadcrumbOrigin } from './components/breadcrumb-origin';
import { initMagazineCategories } from './components/magazine-categories';

// Rende initSelect2 disponibile globalmente per re-inizializzare dopo AJAX
window.celadaSelect2 = { init: initSelect2 };

document.addEventListener('DOMContentLoaded', initBreadcrumbOrigin);
document.addEventListener('DOMContentLoaded', initMagazineCategories);

/**
 * Page Loading Phases
 * 1. is-loading    — script parsed, page still loading
 * 2. is-dom-ready  — DOM fully parsed (DOMContentLoaded)
 * 3. is-loaded     — all resources loaded (window load)
 */
(function () {
	const body = document.body;
	body.classList.add('is-loading');

	document.addEventListener('DOMContentLoaded', function () {
		body.classList.add('is-dom-ready');
	});

	window.addEventListener('load', function () {
		body.classList.remove('is-loading');
		body.classList.add('is-loaded');
	});
})();

let $ = jQuery.noConflict();

// ========== GLOBAL HELPERS (outside $(function)) ==========
// Salva queste funzioni nel window per accesso globale
!(function initGlobalHelpers() {
	// Helper: Verifica se siamo su mobile
	window.isMobile = () => window.innerWidth < 1080;

	/**
	 * Sposta il contenuto accordion dopo il trigger su mobile
	 * @param {string} menuItemId - ID del menu item accordion cliccato
	 * @param {jQuery} $subMenuContainer - Container del sub-menu
	 */
	window.moveAccordionContentMobile = (menuItemId, $subMenuContainer) => {
		if (!window.isMobile()) {
			return;
		}

		// Trova il contenuto accordion corrispondente
		const $accordionContent = $subMenuContainer.find('.inner-menu-wrapper > .sub-menu[data-parent="' + menuItemId + '"]');

		if ($accordionContent.length) {
			// Trova il trigger accordion
			const $trigger = jQuery('#' + menuItemId);

			// Rimuovi qualsiasi accordion mobile esistente (che non sia questo)
			jQuery('.sub-menu--accordion-mobile').each(function() {
				const $this = jQuery(this);
				// Ripristina nella posizione originale SOLO se non è il nostro
				if (!$this.is($accordionContent)) {
					$this.removeClass('sub-menu--accordion-mobile')
						.removeClass('active')
						.appendTo($this.data('original-parent'));
				}
			});

			// Salva il parent originale se non già salvato
			if (!$accordionContent.data('original-parent')) {
				$accordionContent.data('original-parent', $accordionContent.parent());
			}

			// Se è già nel formato mobile, non fare nulla
			if (!$accordionContent.hasClass('sub-menu--accordion-mobile')) {
				// Inserisci il contenuto dopo il trigger
				$accordionContent
					.addClass('sub-menu--accordion-mobile')
					.insertAfter($trigger);
			}
		}
	};

	/**
	 * Ripristina le posizioni originali degli accordion su desktop
	 */
	window.resetAccordionPositions = () => {
		jQuery('.sub-menu--accordion-mobile').each(function() {
			const $this = jQuery(this);
			const $originalParent = $this.data('original-parent');

			if ($originalParent && $originalParent.length) {
				$this.removeClass('sub-menu--accordion-mobile')
					.appendTo($originalParent);
			}
		});
	};
})();

/**
 * Logo ridotto allo scroll
 * .is-scrolled sull'header appena la pagina non è più in cima: il logo si
 * riduce del 15% (_site-header.scss). Indipendente dall'hide/show, che può
 * essere disattivato dalle opzioni.
 */
(function () {
	const header = document.querySelector('header.site-header.wp-block-template-part');
	if (!header) return;

	const scrolledThreshold = 50;
	let ticking = false;

	function update() {
		const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
		header.classList.toggle('is-scrolled', currentScroll > scrolledThreshold);
		ticking = false;
	}

	window.addEventListener('scroll', function () {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}, { passive: true });
	update();
})();

/**
 * Hide/Show Header on Scroll
 * Nascondi l'header quando l'utente scrolla verso il basso (almeno 320px)
 * Mostra l'header quando l'utente scrolla verso l'alto (almeno 320px)
 */
(function () {
	const header = document.querySelector('header.site-header.wp-block-template-part');
	if (!header) return;

	// Con la barra filtri orizzontale (sticky sotto l'header) l'header resta
	// sempre visibile: niente hide/show allo scroll.
	if (document.querySelector('.filter-block--horizontal')) return;

	// Abilitazione da ACF, separata per desktop e mobile (< 1080px).
	// Se l'oggetto non c'è, il comportamento resta attivo ovunque.
	// wp_localize_script passa i valori come stringhe: true = "1", false = "".
	const settings = window.celadaSiteHeader || {};
	const hideDesktop = settings.hideDesktop === undefined || !!settings.hideDesktop;
	const hideMobile = settings.hideMobile === undefined || !!settings.hideMobile;
	if (!hideDesktop && !hideMobile) return;

	function isHideEnabled() {
		return window.isMobile() ? hideMobile : hideDesktop;
	}

	let lastScrollTop = 0;
	let accumulatedScroll = 0;
	let scrollDirection = null; // 'up' o 'down'
	let isHeaderHidden = false;
	const scrollThreshold = 50;

	// Se abilitato da ACF, riporta in vista l'header N secondi dopo che è stato
	// nascosto dallo scroll-down, anche senza risalire con lo scroll.
	// N arriva da ACF (acf_options_siteheader_auto_show_s) già in millisecondi.
	const autoShowEnabled = window.celadaSiteHeader && window.celadaSiteHeader.autoShow;
	const autoShowDelay = (window.celadaSiteHeader && parseInt(window.celadaSiteHeader.autoShowDelay, 10)) || 6000;
	let autoShowTimer = null;

	function showHeader() {
		header.classList.remove('is-hidden');
		isHeaderHidden = false;
	}

	function hideHeader() {
		header.classList.add('is-hidden');
		isHeaderHidden = true;
		if (autoShowEnabled) {
			clearTimeout(autoShowTimer);
			autoShowTimer = setTimeout(showHeader, autoShowDelay);
		}
	}

	// Throttle con requestAnimationFrame: la lettura di layout (scrollTop) e le
	// modifiche DOM girano al massimo una volta per frame, non ad ogni evento
	// scroll (che può emettere decine di eventi al secondo → reflow ripetuti).
	let ticking = false;
	window.addEventListener('scroll', function () {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(function () {
			const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
			const delta = currentScroll - lastScrollTop;

			// Disabilitato per il viewport corrente (anche dopo un resize):
			// header sempre visibile.
			if (!isHideEnabled()) {
				clearTimeout(autoShowTimer);
				if (isHeaderHidden) showHeader();
				accumulatedScroll = 0;
				scrollDirection = null;
				lastScrollTop = currentScroll;
				ticking = false;
				return;
			}

			if (delta > 0) {
				// Scrolling DOWN
				if (scrollDirection !== 'down') {
					accumulatedScroll = 0; // Reset quando cambia direzione
					scrollDirection = 'down';
				}
				accumulatedScroll += delta;
				if (accumulatedScroll >= scrollThreshold && !isHeaderHidden) {
					hideHeader();
					accumulatedScroll = 0; // Reset dopo l'azione
				}
			} else if (delta < 0) {
				// Scrolling UP
				if (scrollDirection !== 'up') {
					accumulatedScroll = 0; // Reset quando cambia direzione
					scrollDirection = 'up';
				}
				accumulatedScroll += Math.abs(delta);
				if (accumulatedScroll >= scrollThreshold && isHeaderHidden) {
					clearTimeout(autoShowTimer);
					showHeader();
					accumulatedScroll = 0; // Reset dopo l'azione
				}
			}

			lastScrollTop = currentScroll;
			ticking = false;
		});
	}, { passive: true });

	// Riporta in vista l'header se il mouse si avvicina alla parte alta
	// della viewport, anche senza scrollare.
	const mouseProximityThreshold = 200;
	let mouseTicking = false;
	window.addEventListener('mousemove', function (e) {
		if (mouseTicking || !isHeaderHidden) return;
		mouseTicking = true;
		requestAnimationFrame(function () {
			if (isHeaderHidden && e.clientY <= mouseProximityThreshold) {
				clearTimeout(autoShowTimer);
				showHeader();
				accumulatedScroll = 0;
				scrollDirection = null;
			}
			mouseTicking = false;
		});
	}, { passive: true });
})();

$(function () {

	// Gestisci il resize per ripristinare le posizioni su desktop
	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			if (!window.isMobile()) {
				window.resetAccordionPositions();
			}
		}, 150);
	});

	$('.mobile-menu-toggle').on('click', function () {
		const isOpen = $('body').hasClass('menu-is-open');
		$('body').toggleClass('menu-is-open');
		$(this).attr('aria-expanded', isOpen ? 'false' : 'true');
		$(this).attr('aria-label', isOpen
			? $(this).data('label-open') || 'Apri menu di navigazione'
			: $(this).data('label-close') || 'Chiudi menu di navigazione'
		);
	});

	// Chiudi menu mobile cliccando fuori da esso
	// $(document).on('click', function (e) {
	// 	// Se il menu mobile non è aperto, esci
	// 	if (!$('body').hasClass('menu-is-open')) {
	// 		return;
	// 	}

	// 	// Se clicchi su .mobile-menu-toggle o dentro ad esso, lascia che faccia il toggle
	// 	if ($(e.target).closest('.mobile-menu-toggle').length) {
	// 		return;
	// 	}

	// 	// Se clicchi dentro al menu (sub-menu-wrapper), non chiudere
	// 	if ($(e.target).closest('.sub-menu-wrapper, .parent-menu').length) {
	// 		return;
	// 	}

	// 	// Altrimenti chiudi il menu
	// 	$('body').removeClass('menu-is-open');
	// });

	$('.parent-menu .menu-item-ancestor.menu-item-has-children').on('click', function (e) {
		// Se il click arriva da dentro .sub-menu-wrapper, lascia passare (navigazione link)
		if ($(e.target).closest('.sub-menu-wrapper').length) {
			return;
		}
		e.preventDefault();
		e.stopPropagation();

		let $wrapper = $(this).find('.sub-menu-wrapper');
		let isAlreadyActive = $wrapper.hasClass('active');

		// Rimuovi la classe active da tutti gli altri sub-menu-wrapper e sub-menu
		$('.sub-menu-wrapper.active').removeClass('active');
		$('.inner-menu-wrapper .sub-menu.active').removeClass('active');
		// Rimuovi is-active da tutti gli accordion items
		$('.menu-item-accordion.is-active').removeClass('is-active');
		// Ripristina posizioni accordion su mobile
		if (window.isMobile()) {
			window.resetAccordionPositions();
		}

		// Se non era già attivo, aprilo
		if (!isAlreadyActive) {
			$wrapper.addClass('active');
			$wrapper.find('.inner-menu-wrapper .sub-menu:first-child').addClass('active');

			// Attiva il primo accordion item del sub-menu appena aperto
			const $firstAccordion = $wrapper.find('.sub-menu:first > .menu-item-accordion:first');
			$firstAccordion.addClass('is-active');

			// Su mobile, sposta il contenuto del primo accordion
			if (window.isMobile() && $firstAccordion.length) {
				const menuItemId = $firstAccordion.attr('id');
				const $subMenuContainer = $wrapper.find('.sub-menu-container');
				window.moveAccordionContentMobile(menuItemId, $subMenuContainer);
			}
		}
	});

	// Chiudi sub-menu-wrapper cliccando fuori
	$(document).on('click', function (e) {
		if (!$(e.target).closest('.sub-menu-wrapper').length) {
			$('.sub-menu-wrapper.active').removeClass('active');
			$('.inner-menu-wrapper .sub-menu.active').removeClass('active');
			$('.menu-item-accordion.is-active').removeClass('is-active');
			// Ripristina posizioni accordion su mobile
		if (window.isMobile()) {
			window.resetAccordionPositions();
			}
		}
	});

	// Chiudi sub-menu-wrapper se si scrolla più di 320px dalla posizione di apertura
	let menuOpenScrollPos = null;

	// Throttle rAF: coalesce gli eventi scroll in un solo controllo per frame.
	let menuScrollTicking = false;
	$(window).on('scroll', function () {
		if (menuScrollTicking) return;
		menuScrollTicking = true;
		requestAnimationFrame(function () {
			if ($('.sub-menu-wrapper.active').length) {
				if (menuOpenScrollPos === null) {
					menuOpenScrollPos = $(window).scrollTop();
				}
				if (Math.abs($(window).scrollTop() - menuOpenScrollPos) > 320) {
					$('.sub-menu-wrapper.active').removeClass('active');
					$('.inner-menu-wrapper .sub-menu.active').removeClass('active');
					$('.menu-item-accordion.is-active').removeClass('is-active');
					// Ripristina posizioni accordion su mobile
					if (window.isMobile()) {
						window.resetAccordionPositions();
					}
					menuOpenScrollPos = null;
				}
			} else {
				menuOpenScrollPos = null;
			}
			menuScrollTicking = false;
		});
	});

	// Click on anchor tags inside .sub-menu.sub-menu-has-children > .menu-item.menu-item-has-children
	$('.sub-menu.sub-menu-has-children > .menu-item.menu-item-has-children > a').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Get the ID of the parent <li>
		let $li = $(this).closest('.menu-item');
		let menuItemId = $li.attr('id');

		// Find the .sub-menu-container that contains everything
		// Usa il sub-menu-wrapper attivo più vicino
		let $subMenuWrapper = $li.closest('.sub-menu-wrapper');
		if (!$subMenuWrapper.hasClass('active')) {
			$subMenuWrapper = $('.sub-menu-wrapper.active');
		}

		let $subMenuContainer = $subMenuWrapper.find('.sub-menu-container');
		let $targetAccordion = null;

		if ($subMenuContainer.length) {
			// Find the .inner-menu-wrapper inside this container
			let $innerMenuWrapper = $subMenuContainer.find('.inner-menu-wrapper');

			if ($innerMenuWrapper.length) {
				// Hide all .sub-menu inside the .inner-menu-wrapper
				$innerMenuWrapper.find('> .sub-menu').removeClass('active');

				// Show only the .sub-menu with data-parent matching the clicked item's ID
				$targetAccordion = $innerMenuWrapper.find('> .sub-menu[data-parent="' + menuItemId + '"]');
				$targetAccordion.addClass('active');

				// Su mobile, sposta il contenuto accordion dopo il trigger
			window.moveAccordionContentMobile(menuItemId, $subMenuContainer);
			}

			// If this is an accordion item, manage is-active class
			if ($li.hasClass('menu-item-accordion')) {
				// Find the parent sub-menu to scope the toggle
				let $parentSubMenu = $li.closest('.sub-menu');

				// Check if this item is already active
				let isAlreadyActive = $li.hasClass('is-active');

				// Remove is-active from all accordion items in the same parent sub-menu
				$parentSubMenu.find('> .menu-item-accordion').removeClass('is-active');

				// If it wasn't already active, make it active
				if (!isAlreadyActive) {
					$li.addClass('is-active');
			} else if (window.isMobile() && $targetAccordion) {
				// Su mobile, se clicco di nuovo sullo stesso, chiudi
				$targetAccordion.removeClass('active');
				window.resetAccordionPositions();
				}
			}
		}

		return false;
	});

	// Counter Up Animation
	initCounterUp();

	// Add accordion-specific class to sub-menus if their parent is an accordion item
	$('.inner-menu-wrapper > .sub-menu').each(function() {
		let $subMenu = $(this);
		let parentId = $subMenu.data('parent');

		// Check if the parent element has the accordion class
		if (parentId) {
			let $parentElement = $('#' + parentId);
			if ($parentElement.hasClass('menu-item-accordion')) {
				$subMenu.addClass('sub-menu--accordion');
			}
		}
	});

	/**
	 * Wrap image inside primary-theme styled blocks
	 */
	const imageBlocks = document.querySelectorAll( '.wp-block-image.is-style-primary-theme' );

	imageBlocks.forEach( ( block ) => {
		const img = block.querySelector( 'img' );
		if ( img && img.parentElement === block ) {
			const wrapper = document.createElement( 'div' );
			wrapper.classList.add( 'wp-block-image-wrapper' );
			block.insertBefore( wrapper, img );
			wrapper.appendChild( img );
		}
	} );
});

/**
 * Counter Up Animation
 * Anima i numeri da 0 al valore finale quando entrano nel viewport
 */
function initCounterUp() {
	const counterElements = document.querySelectorAll('.is-style-counterup');

	// Se non ci sono elementi, esci
	if (!counterElements.length) {
		return;
	}

	// Crea un IntersectionObserver
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			// Se l'elemento è visibile e non è ancora stato animato
			if (entry.isIntersecting && !entry.target.dataset.counterAnimated) {
				animateCounter(entry.target);
				// Marca l'elemento come animato
				entry.target.dataset.counterAnimated = 'true';
				// Smetti di osservare questo elemento
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.1 // Attiva quando il 10% dell'elemento è visibile
	});

	// Osserva tutti gli elementi
	counterElements.forEach((element) => {
		observer.observe(element);
	});
}

/**
 * Anima un singolo counter
 * @param {Element} element - L'elemento con il numero
 */
function animateCounter(element) {
	const finalValue = parseInt(element.textContent, 10);

	// Se non è un numero valido, esci
	if (isNaN(finalValue)) {
		return;
	}

	const duration = 2000; // Durata dell'animazione in ms
	const startTime = performance.now();
	const startValue = 0;

	function updateCounter(currentTime) {
		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1); // 0 a 1

		// Usa easing per un'animazione più fluida
		const easedProgress = easeOutQuad(progress);

		// Calcola il valore attuale
		const currentValue = Math.floor(startValue + (finalValue - startValue) * easedProgress);

		// Aggiorna il testo dell'elemento
		element.textContent = currentValue;

		// Se l'animazione non è finita, continua
		if (progress < 1) {
			requestAnimationFrame(updateCounter);
		} else {
			// Assicurati che il valore finale sia esatto
			element.textContent = finalValue;
		}
	}

	requestAnimationFrame(updateCounter);
}

/**
 * Easing function - Quad ease out
 * @param {Number} t - Valore tra 0 e 1
 * @returns {Number} - Valore eased
 */
function easeOutQuad(t) {
	return t * (2 - t);
}
